import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Card } from '../../../shared/components/ui/Card.js';
import { Input } from '../../../shared/components/ui/Input.js';
import { auditApi } from '../api.js';

export function AuditPage() {
  const [actionFilter, setActionFilter] = useState('');

  const auditQuery = useQuery({
    queryKey: ['audit', actionFilter],
    queryFn: () => auditApi.list({ ...(actionFilter && { action: actionFilter }), limit: 200 }),
  });

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-[24px] font-bold text-n-900">Auditoria</h1>
        <p className="text-[13px] text-n-500">
          Trilha de operações do super-painel (logins, mudanças em servidores, tenants, super-admins).
        </p>
      </div>

      <div className="mb-4 max-w-[300px]">
        <Input
          placeholder="Filtrar por ação (ex: tenant.suspended)"
          value={actionFilter}
          onChange={(e) => setActionFilter(e.target.value)}
        />
      </div>

      <Card>
        <table className="w-full">
          <thead className="border-b border-n-200 bg-n-50 text-left text-[11px] font-semibold uppercase text-n-500">
            <tr>
              <th className="px-5 py-3">Quando</th>
              <th className="px-5 py-3">Ação</th>
              <th className="px-5 py-3">User</th>
              <th className="px-5 py-3">Server</th>
              <th className="px-5 py-3">IP</th>
              <th className="px-5 py-3">Payload</th>
            </tr>
          </thead>
          <tbody>
            {auditQuery.isLoading && (
              <tr>
                <td colSpan={6} className="px-5 py-8 text-center text-[13px] text-n-500">
                  Carregando...
                </td>
              </tr>
            )}
            {auditQuery.data?.length === 0 && (
              <tr>
                <td colSpan={6} className="px-5 py-8 text-center text-[13px] text-n-500">
                  Sem entradas no log.
                </td>
              </tr>
            )}
            {auditQuery.data?.map((e) => (
              <tr key={e.id} className="border-b border-n-100 hover:bg-n-50 align-top">
                <td className="px-5 py-3 text-[11px] font-mono text-n-500 whitespace-nowrap">
                  {new Date(e.created_at).toLocaleString('pt-BR')}
                </td>
                <td className="px-5 py-3 text-[12px]">
                  <code className="rounded bg-brand-50 px-1.5 py-0.5 font-mono text-[11px] text-brand-700">
                    {e.action}
                  </code>
                </td>
                <td className="px-5 py-3 text-[12px] text-n-600">
                  {e.email ?? (e.super_user_id ? `#${e.super_user_id}` : '—')}
                </td>
                <td className="px-5 py-3 text-[12px] text-n-600">
                  {e.server_id ? `#${e.server_id}` : '—'}
                </td>
                <td className="px-5 py-3 text-[11px] font-mono text-n-500">
                  {e.ip_address ?? '—'}
                </td>
                <td className="px-5 py-3 text-[11px]">
                  {e.payload && Object.keys(e.payload).length > 0 ? (
                    <pre className="font-mono text-n-600 whitespace-pre-wrap break-all max-w-[400px]">
                      {JSON.stringify(e.payload, null, 2)}
                    </pre>
                  ) : (
                    <span className="text-n-400">—</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
